const prefix = "LEVY_COLLECTION_OVERRIDES_";

export const COPY_FAILED = prefix + "COPY_FAILED";
export const COPY_STARTED = prefix + "COPY_STARTED";
export const COPY_SUCCEEDED = prefix + "COPY_SUCCEEDED";
export const EDIT_CLEAR = prefix + "EDIT_CLEAR";
export const EDIT_DELETE_FAILED = prefix + "EDIT_DELETE_FAILED";
export const EDIT_DELETE_STARTED = prefix + "EDIT_DELETE_STARTED";
export const EDIT_DELETE_SUCCEEDED = prefix + "EDIT_DELETE_SUCCEEDED";
export const EDIT_GET_FAILED = prefix + "EDIT_GET_FAILED";
export const EDIT_GET_STARTED = prefix + "EDIT_GET_STARTED";
export const EDIT_GET_SUCCEEDED = prefix + "EDIT_GET_SUCCEEDED";
export const EDIT_SAVE_FAILED = prefix + "EDIT_SAVE_FAILED";
export const EDIT_SAVE_STARTED = prefix + "EDIT_SAVE_STARTED";
export const EDIT_SAVE_SUCCEEDED = prefix + "EDIT_SAVE_SUCCEEDED";
export const EDIT_SET_DATA = prefix + "EDIT_SET_DATA";
export const GET_CANDIDATES_FOR_COPYING_FAILED = prefix + "GET_CANDIDATES_FOR_COPYING_FAILED";
export const GET_CANDIDATES_FOR_COPYING_STARTED = prefix + "GET_CANDIDATES_FOR_COPYING_STARTED";
export const GET_CANDIDATES_FOR_COPYING_SUCCEEDED = prefix + "GET_CANDIDATES_FOR_COPYING_SUCCEEDED";
export const GET_ALL_FAILED = prefix + "GET_ALL_FAILED";
export const GET_ALL_STARTED = prefix + "GET_ALL_STARTED";
export const GET_ALL_SUCCEEDED = prefix + "GET_ALL_SUCCEEDED";
export const LIST_FAILED = prefix + "LIST_FAILED";
export const LIST_SET_CRITERIA_DESCRIPTION = prefix + "LIST_SET_CRITERIA_DESCRIPTION";
export const LIST_SET_FILTERS = prefix + "LIST_SET_FILTERS";
export const LIST_SET_PAGING = prefix + "LIST_SET_PAGING";
export const LIST_STARTED = prefix + "LIST_STARTED";
export const LIST_SUCCEEDED = prefix + "LIST_SUCCEEDED";
export const LIST_TOGGLE_EXPAND = prefix + "LIST_TOGGLE_EXPAND";
export const STATE_HIDE_ERROR = prefix + "STATE_HIDE_ERROR";
export const STATE_RESET = prefix + "STATE_RESET";
export const STATE_UNLOAD = prefix + "STATE_UNLOAD";
export const STATE_UNLOAD_LISTING = prefix + "STATE_UNLOAD_LISTING";
export const EXPORT_FAILED = prefix + "EXPORT_FAILED";
export const EXPORT_STARTED = prefix + "EXPORT_STARTED";
export const EXPORT_SUCCEEDED = prefix + "EXPORT_SUCCEEDED";
